import themes from "./themes";

export const resolveTheme = async (brandId, tenantSvc) => {
  // Priority: brandId > tenantId > localStorage > default
  let themeId = null;
  let resolvedTheme = null;

  // Check brandId first
  if (brandId && themes[brandId]) {
    themeId = brandId;
    resolvedTheme = themes[brandId];
  }
  // Fallback to tenantId
  else if (tenantSvc?.tenantId && themes[tenantSvc.tenantId]) {
    themeId = tenantSvc.tenantId;
    resolvedTheme = themes[tenantSvc.tenantId];
  }
  // Fallback to cached theme ID from localStorage
  else {
    const cachedThemeId = localStorage.getItem("portal_brand");
    if (cachedThemeId && themes[cachedThemeId]) {
      themeId = cachedThemeId;
      resolvedTheme = themes[cachedThemeId];
    }
  }

  // Use default if nothing matched
  if (!resolvedTheme) {
    resolvedTheme = themes.default;
  }

  // Cache the resolved theme ID for future use
  if (themeId) {
    localStorage.setItem("portal_brand", themeId);
  }

  return resolvedTheme;
};
